import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { openPopup} from "../../store/popupSlice" 
import { Helmet } from "react-helmet-async";
import Breadcrumb from "../../component/Breadcrumb";

const breadcrumbData = {
  newClass:"center-breadcrumb white-breadcrumb",
  list:[
    {
      page:"Home",
      slug:"/"
    }
  ]
}
export default function HomeBanner  ()  {
  const dispatch=useDispatch();
  return (
    <>
      <Helmet>
        <link rel="preload" fetchpriority="high" href="/assets/home/blackPoster.webp" as="image" type="image/webp" />
      </Helmet>

      <section className="banner-section header-gap">
        <div className="homebanner-detail">
        <video  src={"/assets/home/herovideo2.mp4"} className="img-responsive" autoPlay loop muted  playsInline poster="/assets/home/blackPoster.webp" preload="metadata"/>
          <div>
            <h1 className="heading">Flexible AI-Powered Solutions for Smooth Mobility</h1>
            <p>
              Shaping the Future of <span>AI-Driven Innovation</span> in the Digital Era
            </p>
            <p>21 Days Free Trial | No Credit Card Required</p>
            <Link 
             onClick={() => dispatch(openPopup())}
             className="default-btn animated-btn">
              Book free demo
            </Link>

            <Breadcrumb breadcrumbData={breadcrumbData}/>
          </div>
          <label className="scroll-down-video">
            <FontAwesomeIcon icon={faChevronDown} />
          </label>
        </div>
      </section>
    </>
  );
};
